import { datasetFactory } from '@fusioncharts/core/src/lib';
import MultiAxisDataset from '../dataset/multiaxisline';

/**
 * Function to create the datasets
 */
export default function (chart) {
  let datasetsJSON,
    length,
    indices,
    vC,
    children = chart.getChildren(),
    yAxisSelectorUI = children.yAxisSelectorUI, // eslint-disable-line good-practices/no-single-usage-variable
    canvas = children.canvas[0], // eslint-disable-line good-practices/no-single-usage-variable
    numLen = (length + '').length,
    vCanvas = canvas.getChildren('vCanvas'),
    visibilityChangedHandler = function (e) {
      yAxisSelectorUI.forEach(comp => {
        comp.manipulateCheckBox(e);
      });
    },
    addDatasetVisibilityChangedEventListener = (dataset) => {
      dataset.addEventListener('datasetVisibilityChanged', visibilityChangedHandler);
    };

  for (let i = 0, len = vCanvas.length; i < len; i++) {
    vC = vCanvas[i];
    if (vC.getState('removed')) {
      continue;
    }
    datasetsJSON = vC.getFromEnv('axisData').dataset;
    // vC.addToEnv('axisData', axis);
    if (datasetsJSON) {
      length = datasetsJSON.length;
      // for each dataset its datasetindex is a fractional number where the whole part is the index of its parent axis
      // and the fractional part is its index in that axis
      indices = Array(length).fill(vC.getFromEnv('yAxis').config.axisIndex).map((n, j) => { // eslint-disable-line
        return n + (j + 1) * (1 / Math.pow(10, numLen));
      });
      datasetFactory(vC, MultiAxisDataset, 'dataset', length, datasetsJSON, indices);
      children = vC.getChildren('dataset');
      // Adding event listeners to each dataset
      children.forEach(addDatasetVisibilityChangedEventListener);
    }
  }
}
